import React from 'react';
import { CellProps, WithClassname } from '@jsonforms/core';
import merge from 'lodash/merge';
import { Checkbox } from '@mantine/core';

export const MantineCheckbox = React.memo(
  React.forwardRef(function MantineCheckbox(
    props: CellProps & WithClassname & { label?: string },
    ref: React.Ref<any>
  ) {
    const { data, className, id, enabled, uischema, path, handleChange, config, label } = props;
    const appliedUiSchemaOptions = merge({}, config, uischema.options);

    // !! causes undefined value to be converted to false, otherwise has no effect
    const checked = !!data;

    return (
      <Checkbox
        checked={checked}
        onChange={() => handleChange(path, !checked)}
        className={className}
        id={id}
        disabled={!enabled}
        label={label}
        autoFocus={!!appliedUiSchemaOptions.focus}
        ref={ref}
      />
    );
  })
);
